import React from "react";
import OverlayLayout from "./layouts/overlay";
import SimpleFormLayout from "./layouts/simple-form";
import SplitContentLayout from "./layouts/split-content";
import MultiStepFormLayout from "./layouts/multi-step-form";

const Layout = ({ data }) => {
	switch (data.layout) {
		case "overlay":
			return <OverlayLayout data={data} />;
		case "simpleForm":
			return <SimpleFormLayout data={data} />;
		case "splitContent":
			return <SplitContentLayout data={data} />;
		case "multiStepForm":
			return <MultiStepFormLayout data={data} />;
		default:
			return null;
	}
};

const ModProForm = ({ data }) => (
	<Layout data={data} />
);


export default ModProForm;